import { pdfjs } from 'react-pdf';

// CRA cannot reliably bundle the pdfjs worker via import.meta.url; use a version-matched CDN worker.
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;
